import { Component, OnInit, Input, Output, EventEmitter, EmbeddedViewRef, TemplateRef, ViewContainerRef, NgZone, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import Popper from 'popper.js';
import { fromEvent, BehaviorSubject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'tca-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit {
  @ViewChild('origin', { static: true}) componentOrigin: ElementRef;
  @Input() options: [];
  @Input() placeholder = 'Select';
  @Output() selectChange: EventEmitter<any> = new EventEmitter();
  @Output() closed = new EventEmitter();
  @Input() disabled = false;

  get visibleOptions() {
    if (this.options.length >= 4) {
      return 4;
    }

    return this.options.length;
  }

  modelValue: any;
  @Output() modelChange = new EventEmitter<any>();
  @Input() get model(): any {
    return this.modelValue;
  }

  set model(value: any) {
    this.modelValue = value;
    this.modelChange.emit(this.modelValue);
  }

  optionWidth = '0px';

  private view: EmbeddedViewRef<any>;
  private popperRef: Popper;

  constructor(
    private vcr: ViewContainerRef,
    private zone: NgZone,
    private cdr: ChangeDetectorRef
  ) { }

  get isOpen() {
    return !!this.popperRef;
  }

  ngOnInit() {
    if (this.model) {
      this.model = this.options.find(x => x['id'] === this.model['id'] && x['text'] === this.model['text']);
    }

    this.optionWidth = `${this.componentOrigin.nativeElement.offsetWidth - 20}px`;
  }

  onSelect() {
    this.selectChange.emit(this.model);
  }

  open(dropdownTpl: TemplateRef<any>, origin: HTMLElement) {
    if (this.disabled) {
      return;
    }

    if (!this.options || this.options.length === 0) {
      return;
    }

    if (this.isOpen) {
      this.close();
      return;
    }

    if (!this.isOpen) {
      this.view = this.vcr.createEmbeddedView(dropdownTpl);
      const dropdown = this.view.rootNodes[0];

      document.body.appendChild(dropdown);
      dropdown.style.width = `${origin.offsetWidth}px`;

      this.zone.runOutsideAngular(() => {
        this.popperRef = new Popper(origin, dropdown, {
          removeOnDestroy: true
        });
      });

      this.handleClickOutside();
    }
  }

  close() {
    this.closed.emit();
    this.popperRef.destroy();
    this.view.destroy();
    this.view = null;
    this.popperRef = null;
  }

  select(option) {
    this.model = option;
    this.selectChange.emit(option);
  }

  private handleClickOutside() {
    fromEvent(document, 'click')
      .pipe(
        filter(({ target }) => {
          const origin = this.popperRef.reference as HTMLElement;
          return origin.contains(target as HTMLElement) === false;
        }),
        takeUntil(this.closed)
      )
      .subscribe(() => {
        this.close();
        this.cdr.detectChanges();
      });
  }

  isActive(option) {
    if (!this.model) {
        return false;
    }
    return option.text === this.model.text && option.id === this.model.id;
  }

}
